import "core-js/modules/es.object.to-string";
import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getStationDailyRiskCounters } from '@/api/bairun/financialCenter';
import dateUtils from '@/utils/dateUtil';
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {
  name: 'ConsumeRisk',
  components: {},
  data: function data() {
    return {
      consumeDialog: false,
      nextStep: false,
      dialogLoading: false,
      consumeList: [],
      dailyConsumeRiskData: [],
      shiftConsumeRiskData: [],
      datePickerValue: [dateUtils.todayTimestamp() * 1000, dateUtils.todayTimestamp() * 1000],
      downloadLoading: false,
      excelSheets: [{
        tableId: 'dailyConsumeRiskData',
        name: '消费风控数据'
      }],
      selectedStation: {
        'ID': 0,
        'stationName': '',
        'statTag': '选择站点',
        'statAbbr': '',
        'appId': 'aaa'
      },
      consumeTotal: 0,
      dialogSearchForm: {
        page: 1,
        pageSize: 20,
        mobile: '',
        goodsType: 999,
        startDate: 0,
        shiftDate: '',
        endDate: 0,
        sellerOrderType: 1
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('user', ['userInfo'])), mapGetters('stations', ['asyncStations'])),
  watch: {},
  created: function created() {// this.loadData()
  },
  updated: function updated() {},
  methods: {
    dateNormalFormat: function dateNormalFormat(ts) {
      if (!ts) {
        return '';
      }

      return dateUtils.normalFormat(ts, 'YYYY-MM-DD HH:mm:ss');
    },
    riskSearch: function riskSearch() {
      var _this = this;

      if (this.selectedStation.ID === 0) {
        _Message({
          message: '请选择具体的站点',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (moment(this.datePickerValue[1]).diff(moment(this.datePickerValue[0])) < 0) {
        _Message({
          message: '时间选择有误',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (moment(this.datePickerValue[1]).diff(moment(this.datePickerValue[0])) > 92 * 86400000) {
        _Message({
          message: '时间跨度不能超过三个月',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      this.downloadLoading = true;
      getStationDailyRiskCounters({
        sellerId: this.selectedStation.ID,
        startDate: moment(this.datePickerValue[0]).format('YYYYMMDD'),
        endDate: moment(this.datePickerValue[1]).format('YYYYMMDD')
      }).then(function (response) {
        _this.downloadLoading = false; // console.log('getStationDailyRiskCounters', response)

        var res = response.data;
        _this.dailyConsumeRiskData = res.dailyConsumeRiskData || [];
        _this.shiftConsumeRiskData = res.shiftConsumeRiskData || [];
        _this.nextStep = _this.dailyConsumeRiskData.length > 0;
      }).catch(function () {
        _this.downloadLoading = false;
      });
    },
    exportExcel: function exportExcel(tableArr, excelName) {
      var _this2 = this;

      if (this.selectedStation.ID === 0) {
        _Message({
          message: '请选择具体的站点',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (tableArr.length < 1) {
        _Message({
          message: '导出 sheet 为空',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (!this.nextStep) {
        _Message({
          message: '查询的数据为空',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      this.downloadLoading = true;
      import('@/utils/Export2Excel').then(function (excel) {
        excel.export_table_to_excel(tableArr, _this2.selectedStation.statTag + moment(_this2.datePickerValue[0]).format('YYYY年MM月DD日') + '~' + moment(_this2.datePickerValue[1]).format('YYYY年MM月DD日') + excelName);
        _this2.downloadLoading = false;
      });
    }
  }
};